import React from 'react';
import { AgendaTitle } from './AgendaTitle';
import { AgendaView } from './AgendaView';
import { Tab } from './types';

import { INFINITE } from '../../../Agenda/constants';

export const AgendaDrawerContent = ({ tabs }: { tabs: Tab[] }) => {
    return (
        <div>
            <AgendaTitle />
            <AgendaView tabs={tabs} maxSlots={INFINITE} />
        </div>
    );
};
